import type { DbClient } from "@tanstack/react-db";
import type { QueryClient } from "@tanstack/react-query";
import { prefetchWagsListings } from "@/features/listings";
import {
    getSavedListingIdsCollection,
    prefetchRecentlyViewedListingIds,
} from "@/features/saved-listings";
import { seoMeta } from "@/lib/ui/seo";

export const savedDogsRoute = {
    ssr: "data-only" as const,
    loader: async ({
        context,
    }: {
        context: { dbClient: DbClient; queryClient: QueryClient };
    }) => {
        const recentlyViewedHydration = prefetchRecentlyViewedListingIds(
            context.queryClient,
        )
            .then((items) =>
                prefetchWagsListings(
                    context.dbClient,
                    items.map((item) => item.listingId),
                ),
            )
            .catch(() => {});
        const savedListingsCollection = getSavedListingIdsCollection(
            context.dbClient,
        );
        await savedListingsCollection.preload().catch(() => {});
        return {
            listingHydrationPromise: Promise.all([
                prefetchWagsListings(
                    context.dbClient,
                    savedListingsCollection.toArray.map(
                        (savedListing) => savedListing.listingId,
                    ),
                ).catch(() => {}),
                recentlyViewedHydration,
            ]).then(() => {}),
        };
    },
    head: () => ({
        ...seoMeta({
            title: "Saved Dogs — Wags",
            description: "View your saved dogs on Wags.",
            url: "/saved",
        }),
    }),
};
